import axios from 'axios'
import { Api, AuthToken } from './consts'
export const GET_SETTINGS = 'settings/GET_SETTINGS'
export const UPDATE_SETTINGS = 'settings/UPDATE_SETTINGS'
export const TOGGLE_UPDATED = 'settings/TOGGLE_UPDATED'

const initialState = {
    settings: {},
    updated: false
}

export default (state = initialState, action) => {
    switch(action.type) {
        case GET_SETTINGS:
            return {
                ...state,
                settings: action.payload
            }
        case UPDATE_SETTINGS:
            return {
                ...state,
                settings: action.payload,
                updated: true
            }
        case TOGGLE_UPDATED:
            return {
                ...state,
                updated: !state.updated
            }
        default:
            return state
    }
}

const get_settings = settings => ({
    type: GET_SETTINGS,
    payload: settings
})

const update_settings = settings => ({
    type: UPDATE_SETTINGS,
    payload: settings
})

const toggle_updated = () => ({
    type: TOGGLE_UPDATED
})

export const getSettings = () => {
    return dispatch => {
        axios.get(`${Api}/settings`)
            .then((response) => {
                dispatch(get_settings(response.data))
            })
            .catch((error) => {
                console.log(error)
            })
    }
}

export const updateSettings = settings => {
    return dispatch => {
        axios.post(`${Api}/settings/update`, settings)
            .then((response) => {
                dispatch(update_settings(settings))
                return setTimeout(() => {
                    dispatch(toggle_updated())
                }, 3000)
            })
            .catch((error) => {
                alert(`Error updating`)
            })
    }
}


// WEBPACK FOOTER //
// ./src/modules/settings.js